import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import inflection from "inflection";
import React, { useState } from "react";
import { Confirm, Record, useTranslate } from "react-admin";
import {
  PublicApiRedirectionListDto,
  PublicApiRedirectionApiFactory,
} from "../../../common/data/service-proxies";
import { useAxiosInstance } from "../../../common/hooks/useAxiosInstance";
import { isBoolean } from "lodash";
import { useRefresh } from "react-admin";

interface Props {
  label: string;
  icon: JSX.Element;
  record?: (PublicApiRedirectionListDto & Record) | undefined;
  resource?: string | undefined;
  confirmTitle?: string;
  confirmContent?: string;
  hidden?:
    | boolean
    | ((record: PublicApiRedirectionListDto & Record) => boolean);
  onClick?: (event: React.MouseEvent) => void;
  onSuccess?: () => void;
}

export const ApproveRedirectedApiMenuItem = ({
  label,
  record,
  resource,
  confirmTitle,
  confirmContent,
  hidden,
  onClick,
  icon,
  onSuccess,
  ...rest
}: Props) => {
  const [isConfirmOpen, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const axios = useAxiosInstance();
  const translate = useTranslate();

  const refresh = useRefresh();

  if (!record) {
    return null;
  }

  if (isBoolean(hidden)) {
    if (hidden) {
      return null;
    }
  } else {
    if (hidden && hidden(record)) {
      return null;
    }
  }

  if (!confirmTitle) {
    confirmTitle = "resources.public-api-redirection.labels.approve_title";
  }

  if (!confirmContent) {
    confirmContent = "resources.public-api-redirection.labels.approve_content";
  }

  const handleDialogClose = () => {
    setConfirmOpen(false);
  };

  const handleApprove = () => {
    if (!axios) {
      return;
    }

    setLoading(true);
    PublicApiRedirectionApiFactory(undefined, axios.defaults.baseURL, axios)
      .apiAppPublicapiredirectionIdApprovePost(record.id!)
      .then(() => {
        setConfirmOpen(false);
        if (onSuccess) onSuccess();
        refresh();
      })
      .catch((e) => console.error(e))
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <MenuItem
        {...rest}
        className="actions-menu-item"
        onClick={(e) => {
          setConfirmOpen(true);
          if (typeof onClick === "function") {
            onClick(e);
          }
        }}
      >
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText>{translate(label, { _: label })}</ListItemText>
      </MenuItem>
      <Confirm
        isOpen={isConfirmOpen}
        loading={loading}
        title={confirmTitle}
        content={confirmContent}
        translateOptions={{
          name: inflection.singularize(
            translate(`resources.${resource}.forcedCaseName`, {
              smart_count: 1,
              _: inflection.humanize(
                translate(`resources.${resource}.name`, {
                  smart_count: 1,
                  _: inflection.singularize(resource!),
                }),
                true
              ),
            })
          ),
          id: record!.id,
        }}
        onConfirm={handleApprove}
        onClose={handleDialogClose}
      />
    </>
  );
};
